import React from 'react'
import { useReactAlert } from '../../hooks/useReactAlert'

export const withReactAlert = (Component: React.ElementType) => {
  return function WrappedComponent(props: any) {
    const { catchErrorAlert, reactAlert } = useReactAlert()
    return <Component {...props} reactAlert={reactAlert} catchErrorAlert={catchErrorAlert} />
  }
}
